// --- START OF FILE public/landingpage/js/video.js ---
/**
 * Contiene l'URL dell'ultima live/video da mostrare nella sezione "Entra nel Manicomio"
 * e il tempo di inizio desiderato.
 * AGGIORNA MANUALMENTE QUESTI VALORI QUANDO NECESSARIO.
 */

window.latestVideoData = {
    // Incolla qui l'URL completo di condivisione da YouTube (es. https://youtu.be/xxxxxx o https://www.youtube.com/watch?v=xxxxxx)
    url: "https://youtu.be/nNv5xly1vhQ?si=VzfD7ktxakyjopTN", // <-- INCOLLA QUI L'URL DA YOUTUBE
  
    // Specifica il tempo di inizio in secondi (0 per iniziare dall'inizio)
    startTimeSeconds: 170 // <-- IMPOSTA QUI I SECONDI
  };
  
  // --- END OF FILE public/landingpage/js/video.js ---